import type { SxProps, Theme } from '@mui/material/styles'
import { palettePrimaryMain as instrumentTagPrimaryBg } from '@/theme/designTokens'


/** Figma 🔐 Brushfire Web Dev Handoff — Container / LOI list (node 4255:2529). */

export const loiCardBorderColor = '#e1e7ef'
export const loiCardPrimaryOuterBg = 'rgba(236, 250, 255, 0.58)'
export const loiCardPrimaryInnerBg = '#f1faff'
export const loiCardInactiveSurface = '#ffffff'

export const loiTitleColor = '#0f1729'
export const loiBodyColor = '#65758b'

const primaryBadgeBg = '#1aa24c'
const primaryBadgeColor = '#f8fafc'
const upNextBadgeBg = '#f1f5f9'
const upNextBadgeColor = '#65758b'

const instrumentTagPrimaryFg = '#f8fafc'
const instrumentTagSecondaryBg = '#f1f5f9'
const instrumentTagSecondaryFg = '#65758b'

/** Primary vs Up Next rank pill (Figma 4255:2582 / 4255:2599). */
export function loiRankBadgeChipSx(isPrimary: boolean): SxProps<Theme> {
  return {
    height: 20,
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '16px',
    bgcolor: isPrimary ? primaryBadgeBg : upNextBadgeBg,
    color: isPrimary ? primaryBadgeColor : upNextBadgeColor,
    border: 'none',
    '& .MuiChip-label': { px: 1.25, py: 0.25 },
  }
}

/** Instrument tags: blue on primary LOI row, grey on others (Figma 4255:2587 vs 4255:2604). */
export function loiInstrumentTagChipRowSx(isPrimaryRow: boolean): SxProps<Theme> {
  if (isPrimaryRow) {
    return {
      height: 28,
      fontSize: 12,
      fontWeight: 400,
      lineHeight: '16px',
      bgcolor: instrumentTagPrimaryBg,
      color: instrumentTagPrimaryFg,
      border: `1px solid ${instrumentTagPrimaryBg}`,
      '& .MuiChip-label': { px: 1.25, py: 0.5 },
    }
  }
  return {
    height: 28,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
    bgcolor: instrumentTagSecondaryBg,
    color: instrumentTagSecondaryFg,
    border: 'none',
    '& .MuiChip-label': { px: 1.25, py: 0.5 },
  }
}
